import { ChangeEvent, useState } from "react";

export type AccountId = "gamedays-tu-darmstadt" | "serious-games-group-tu-darmstadt";

interface DataUploaderProps {
  onUploadSuccess?: () => void; // to reload visualizations
}

interface FileResult {
  account?: "gamedays-tu-darmstadt" | "serious-games-group-tu-darmstadt";
  filename: string;
  rowsFound: number;
  error?: string;
}

export default function DataUploader({ onUploadSuccess } : DataUploaderProps){
    const[fileNames, setFileNames] = useState<string[]>([]);
    const[isUploading, setIsUploading] = useState(false);
    const[error, setError] = useState<string|null>(null);
    const[fileResults, setFileResults] = useState<FileResult[]>([]);

    async function handleFileChange(e: ChangeEvent<HTMLInputElement>) {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        setFileNames(Array.from(files).map((f) => f.name));
        setIsUploading(true);
        setError(null)
        setFileResults([]);

        try {
          const formData = new FormData();
          Array.from(files).forEach((file) => {
        formData.append("files", file); // same fieldname in each file, as in Backend "files"
      });

          const response = await fetch("/api/upload-data", {
            method: "POST",
            body: formData, // do not set Content-Type-Header as Browser will set it automatically
          });

          if(!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || "Upload fehlgeschlagen");
          }

          const result = await response.json();
          setFileResults(result.fileResults ?? []);
          onUploadSuccess?.();
        } catch(err){
          setError(err instanceof Error ? err.message : "Unbekannter Fehler");
        } finally {
          setIsUploading(false);
        }
    }

    return (
    <div className="file-input-wrapper">
      <label className="file-input-label">
        {isUploading ? "Wird hochgeladen..." : "LinkedIn - Excel hochladen"}
        <input
          type="file"
          accept=".xlsx,.xls"
          multiple
          className="file-input-hidden"
          onChange={handleFileChange}
          disabled={isUploading}
        />
      </label>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
    );
}